import clsx from 'clsx'
import React from 'react'

export default function CustomHTMl({ html, setContainer }) {
	return (
		<div
			className={clsx(setContainer && 'section')}
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	)
}
